export default {
    access_denied: "Acceso denegado",
    filter_placeholder: "Filtrar por Nombre del Establecimiento",
    add_place: "Agregar Establecimiento",
    edit_place: "Editar Establecimiento",
    form: {
        logo: "Logo",
        logo_title: "Logo del Establecimiento",
        name: "Nombre",
        name_title: "Nombre del Establecimiento",
        slug: "Slug",
        slug_title: "Slug del Establecimiento",
        address: "Dirección",
        address_title: "Dirección del Establecimiento",
        address_2: "Complemento",
        address_2_title: "Complemento de la Dirección del Establecimiento",
        zone: "Barrio",
        zone_title: "Barrio del Establecimiento",
        city: "Ciudad",
        city_title: "Ciudad del Establecimiento",
        state: "Estado",
        state_title: "Estado del Establecimiento",
        zip_code: "CEP",
        zip_code_title: "CEP del Establecimiento",
        phone: "Teléfono",
        phone_title: "Teléfono del Establecimiento",
        phone_placeholder: "(##) #####-####",
        legal_name: "Razón Social",
        legal_name_title: "Razón Social del Establecimiento",
        tax_id: "Documento Fiscal",
        tax_id_title: "Documento Fiscal del Establecimiento",
        email: "Correo Electrónico",
        email_title: "Correo Electrónico del Establecimiento",
        color: "Color",
        color_title: "Color del Establecimiento",
        color_placeholder: "FFFFFF",
        timezone: "Zona horaria",
        timezone_title: "Zona horaria del Establecimiento",
        country: "País",
        country_title: "País del Establecimiento",
        currency: "Moneda",
        currency_title: "Moneda del Establecimiento",
        credits_per_month: "Créditos SMS por mes",
        credits_per_month_title: "Crédito del Establecimiento",
        modules: "Módulos",
        modules_helper: "Seleccione uno o más módulos",
        modules_title: "Módulos del Establecimiento",
        none: "Ninguno",
        all: "Todos",
        copy_automations_from: "Copiar Automatizaciones de:",
        kevi_marketing: "Acceso a Kevi Marketing",
        kevi_chat: "Acceso a Kevi Chat",
        yes: "Sí",
        no: "No",
        save: "Guardar",
        notification: {
            fill_fields: "Atención! Complete todos los campos correctamente.",
            saved: "¡Datos guardados con éxito!",
            updated: "¡Establecimiento actualizado con éxito!",
            update_error: "Error al actualizar el establecimiento.",
            load_error: "Error al cargar los datos del establecimiento.",
        },
        validation: {
            logo_required: "El logo es obligatorio.",
            name_required: "El nombre es obligatorio.",
            slug_required: "El slug es obligatorio.",
            slug_format:
                "El slug solo puede tener letras minúsculas, números y -. Máximo de 20 caracteres.",
            address_required: "La dirección es obligatoria.",
            address_2_required: "El complemento es obligatorio.",
            zone_required: "El barrio es obligatorio.",
            city_required: "La ciudad es obligatoria.",
            state_required: "El estado es obligatorio.",
            zip_code_required: "El CEP es obligatorio.",
            phone_required: "El teléfono es obligatorio.",
            phone_format:
                "Ingrese un teléfono válido para el país seleccionado.",
            color_required: "El color es obligatorio.",
            color_format:
                "El color debe estar en formato hexadecimal (ej: FFFFFF).",
            credits_per_month_required:
                "Los créditos SMS por mes son obligatorios.",
            credits_per_month_positive:
                "Los créditos SMS por mes deben ser un número positivo.",
            modules_required: "Seleccione al menos un módulo.",
            legal_name_required: "La razón social es obligatoria.",
            tax_id_required: "El documento fiscal es obligatorio.",
            email_required: "El correo electrónico es obligatorio.",
            email_format: "Ingrese un correo electrónico válido.",
            plan_required: "El plan es obligatorio.",
            change_reason_required: "El motivo del cambio es obligatorio.",
        },
        states: {
            AC: "Acre",
            AL: "Alagoas",
            AP: "Amapá",
            AM: "Amazonas",
            BA: "Bahía",
            CE: "Ceará",
            DF: "Distrito Federal",
            ES: "Espírito Santo",
            GO: "Goiás",
            MA: "Maranhão",
            MT: "Mato Grosso",
            MS: "Mato Grosso do Sul",
            MG: "Minas Gerais",
            PA: "Pará",
            PB: "Paraíba",
            PR: "Paraná",
            PE: "Pernambuco",
            PI: "Piauí",
            RJ: "Río de Janeiro",
            RN: "Río Grande do Norte",
            RS: "Río Grande do Sul",
            RO: "Rondônia",
            RR: "Roraima",
            SC: "Santa Catarina",
            SP: "São Paulo",
            SE: "Sergipe",
            TO: "Tocantins",
        },
        countries: {
            BR: "Brasil",
            US: "Estados Unidos",
            CA: "Canadá",
            AR: "Argentina",
            UY: "Uruguay",
            PY: "Paraguay",
            CL: "Chile",
            CO: "Colombia",
            PE: "Perú",
            MX: "México",
            PT: "Portugal",
            ES: "España",
            FR: "Francia",
            DE: "Alemania",
            IT: "Italia",
            GB: "Reino Unido",
        },
        currencies: {
            BRL: "Real Brasileño",
            USD: "Dólar Estadounidense",
            CAD: "Dólar Canadiense",
            EUR: "Euro",
            ARS: "Peso Argentino",
            UYU: "Peso Uruguayo",
            PYG: "Guaraní Paraguayo",
            CLP: "Peso Chileno",
            COP: "Peso Colombiano",
            PEN: "Sol Peruano",
            MXN: "Peso Mexicano",
            GBP: "Libra Esterlina",
        },
    },
    branch_form: {
        title: "Agregar Sucursal",
        title_label: "Título",
        title_title: "Título de la Sucursal",
        address: "Dirección",
        address_title: "Dirección de la Sucursal",
        address_2: "Complemento",
        zone: "Barrio",
        city: "Ciudad",
        city_title: "Ciudad de la Sucursal",
        state: "Estado",
        state_title: "Estado de la Sucursal",
        country: "País",
        country_title: "País de la Sucursal",
        zip_code: "CEP/Código Postal",
        zip_code_title: "CEP o Código Postal de la Sucursal",
        phone: "Teléfono",
        phone_title: "Teléfono de la Sucursal",
        phone_placeholder: "(##) #####-####",
        active: "Activo",
        active_title: "Estado de la sucursal",
        email: "Correo electrónico",
        email_title: "Correo electrónico de la Sucursal",
        whatsapp: "WhatsApp",
        no_whatsapp_instance: "Ninguna instancia vinculada",
        cancel: "Cancelar",
        confirm: "Confirmar",
        yes: "Sí",
        no: "No",
        notification: {
            fill_fields: "Atención! Complete todos los campos correctamente.",
            saved: "¡Sucursal guardada con éxito!",
        },
        validation: {
            title_required: "El título es obligatorio.",
            address_required: "La dirección es obligatoria.",
            city_required: "La ciudad es obligatoria.",
            state_required: "El estado es obligatorio.",
            zip_code_required: "El CEP/código postal es obligatorio.",
            active_required: "Activo es obligatorio.",
            email_valid: "El correo electrónico debe ser válido.",
            phone_required: "El teléfono es obligatorio.",
            phone_format:
                "Ingrese un teléfono válido para el país seleccionado.",
        },
    },
    user_form: {
        title: "Agregar usuario",
        name: "Nombre",
        name_title: "Nombre del Usuario",
        email: "Correo electrónico",
        email_title: "Correo electrónico del Usuario",
        whatsapp: "WhatsApp",
        no_whatsapp_instance: "Ninguna instancia vinculada",
        global_admin: "Administrador Global",
        global_admin_title: "Permiso del Usuario",
        global_admin_warning:
            "Este usuario tendrá acceso a todos los establecimientos de Kevi.",
        is_internal: "Uso interno de Kevi",
        is_internal_title: "Uso interno de Kevi",
        active: "Activo",
        active_title: "Actividad del Usuario",
        branch: "Sucursal",
        branch_title: "Sucursal del Usuario",
        roles: "Roles",
        username: "Username",
        username_title: "Username del Usuario",
        password: "Contraseña",
        password_title: "Contraseña del Usuario",
        kevi_marketing_enabled: "Acceso a Kevi Marketing",
        kevi_marketing_enabled_title: "Permite iniciar sesión y usar Kevi Marketing",
        kevi_chat_enabled: "Acceso a Kevi Chat",
        kevi_chat_enabled_title: "Permite iniciar sesión y usar Kevi Chat",
        kevi_presence: "Presencia en los productos",
        kevi_presence_hint_marketing_only:
            "Para vincular a Kevi Chat, configure «Acceso a Kevi Chat» como Sí arriba y guarde el usuario.",
        presence_both: "Kevi Marketing y Kevi Chat",
        presence_marketing: "Solo Kevi Marketing",
        presence_chat: "Solo Kevi Chat",
        presence_none: "Sin acceso a los productos",
        permissions: "Permisos",
        cancel: "Cancelar",
        confirm: "Confirmar",
        yes: "Sí",
        no: "No",
        notification: {
            fill_fields: "Atención! Complete todos los campos correctamente.",
            saved: "¡Usuario guardado con éxito!",
        },
        permission: {
            dashboard: "Dashboard",
            dashboard_help: "Accede al panel y a las operaciones del PDV.",
            inbox: "Inbox",
            inbox_help: "Accede a conversaciones y mensajes de clientes.",
            tasks: "Tareas",
            tasks_help: "Accede y gestiona las tareas del equipo.",
            coupons: "Cupones",
            coupons_help: "Accede a la creación y gestión de cupones.",
            clients: "Clientes",
            clients_help: "Accede a la base de clientes y sus datos.",
            segments: "Segmentos",
            segments_help: "Accede a la creación y gestión de segmentos.",
            rewards: "Recompensas",
            rewards_help: "Accede al programa de recompensas.",
            reports: "Reportes",
            reports_help: "Accede a métricas y reportes del producto.",
            forms: "Formularios",
            forms_help: "Accede a formularios y respuestas.",
            automations: "Automatizaciones",
            automations_help: "Accede a la creación y gestión de automatizaciones.",
            balance: "Créditos SMS",
            balance_help: "Accede al saldo y consumo de créditos SMS.",
            configs: "Configuraciones",
            configs_help: "Accede a la configuración del establecimiento.",
            quotations: "Presupuestos",
            quotations_help: "Accede a presupuestos y propuestas.",
            mcp: "MCP",
            mcp_help: "Accede al MCP e integraciones de agentes.",
            invoices: "Facturas",
            invoices_help: "Accede a facturas y cobros del plan.",
            benefit_programs: "Centro de Beneficios",
            benefit_programs_help: "Accede al Centro de Beneficios.",
            access_operations: "¿A qué operaciones tiene acceso el usuario?",
            access_tasks: "¿A qué tareas tiene acceso el usuario?",
            access_quotations: "¿A qué presupuestos tiene acceso el usuario?",
            global_access: "Tiene acceso a los datos de todas las sucursales",
            delete_clients: "Puede eliminar clientes",
            dashboard_access_title: "Operaciones del dashboard",
            tasks_access_title: "Acceso del Usuario a Tareas",
            quotations_access_title: "Acceso del Usuario a Presupuestos",
            level_insert: "Inserción",
            level_read: "Lectura",
            scope_mine: "Propias",
            scope_mine_plural: "Propios",
            scope_branch: "De la unidad",
            scope_all_feminine: "Todas",
            scope_all_plural: "Todos",
        },
        validation: {
            name_required: "El nombre es obligatorio.",
            name_min_length: "El nombre debe tener al menos 3 caracteres.",
            email_required: "El correo electrónico es obligatorio.",
            email_valid: "El correo electrónico debe ser válido.",
            email_taken: "Este correo electrónico ya está en uso.",
            password_required: "La contraseña es obligatoria.",
            password_min_length:
                "La contraseña debe tener al menos 6 caracteres.",
            permissions_required: "El permiso es obligatorio.",
            is_internal_required: "El uso interno es obligatorio.",
            active_required: "Activo es obligatorio.",
            branch_required: "La sucursal es obligatoria.",
            username_required: "El username es obligatorio.",
            username_min_length:
                "El username debe tener al menos 3 caracteres.",
            username_taken: "Este username ya está en uso.",
            tasks_access_required:
                "El acceso del usuario a tareas es obligatorio.",
            quotations_access_required:
                "El acceso del usuario a presupuestos es obligatorio.",
            dashboard_access_required:
                "Las operaciones del PDV son obligatorias.",
        },
    },
    plan: {
        title: "Plan ({0})",
        billing_type: "Tipo de facturación",
        billing_type_prepaid: "Prepago",
        billing_type_postpaid: "Postpago",
        base_fee: "Valor base",
        incentivized_revenue_share: "% De la facturación incentivada",
        retention_revenue_share: "% De la facturación de retención",
        pricetable_clients: "Tabla de precios de clientes",
        pricetable_credits: "Tabla de precios de créditos",
        pricetable_extra_credits: "Tabla de precios de créditos extra",
        included_integrations: "Integraciones incluidas",
        price_per_integration: "Precio por integración extra",
        included_branches: "Sucursales incluidas",
        price_per_branch: "Precio por sucursal",
        included_users: "Usuarios incluidos",
        price_per_user: "Precio por usuario",
        save: "Guardar",
        notification: {
            saved: "Plan actualizado con éxito",
            no_changes: "No se detectaron cambios.",
            change_reason_required: "Indique el motivo del cambio antes de guardar.",
        },
    },
    // Details section
    details: {
        access_denied: "Acceso denegado",
        activate: "Activar",
        activate_automations: "Activar automatizaciones",
        automations_locked: "Automatizaciones bloqueadas",
        automations_off: "Automatizaciones apagadas",
        automations_on: "Automatizaciones encendidas",
        block: "Bloquear",
        deactivate_automations: "Desactivar automatizaciones",
        edit_info: "Editar información",
        manage_plan: "Gestionar plan",
        place_activated: "Establecimiento activado",
        place_blocked: "Establecimiento bloqueado",
        view_as: "Ver como",
    },
    // Branches section
    branches: {
        add_branch: "Agregar sucursal",
        neighborhood_city: "Barrio/Ciudad", 
        title: "Sucursales",
        main_place_badge: "Matriz",
    },
    // Modules section
    modules: {
        title: "Módulos",
        updated: "Módulos actualizados",
    },
    // Products section
    products: {
        title: "Productos Kevi",
        updated: "Productos actualizados",
        at_least_one: "Al menos un producto debe permanecer activo.",
        update_error: "Error al actualizar productos.",
        names: {
            1: "Kevi Marketing",
            2: "Kevi Chat",
        },
    },
    // Plugins section
    plugins: {
        add_plugin: "Agregar plugin",
        choose_plugin: "Elegir plugin",
        created_at: "Creado en",
        external_id: "ID externo",
        settings_updated: "Configuraciones actualizadas",
        title: "Plugins",
    },
    // Roles section
    roles: {
        new_role_placeholder: "Ingrese el nombre del nuevo rol",
        role_added: "Rol agregado",
        role_deleted: "Rol eliminado",
        role_updated: "Rol actualizado",
        title: "Roles",
    },
    // Users section
    users: {
        active: "Usuarios activos",
        add_user: "Agregar usuario",
        title: "Usuarios",
    },
    selected: "Seleccionado",
    view_as: "Ver como",
    no_places_found: "No se encontraron establecimientos",
    usage_report: {
        title: "Reporte de Uso",
        general: "General",
        establishment: "Establecimiento",
        orders: "Pedidos",
        total_income: "Ingresos totales",
        new_clients: "Nuevos clientes",
        sign_ups: "Registros",
        sign_up_rate: "Tasa de registro",
        used_coupons: "Cupones utilizados",
        used_rewards: "Recompensas utilizadas",
        date: "Fecha",
        empty: "No hay suficientes datos para el período",
    },
    email_generator: {
        title: "Generador de Correo",
        placeholder: "predeterminado",
    },
};
